import { ExerciseType } from "@/components/v3/exercises/ExerciseBadge";
import { SpinnerLoader } from "@/components/ui/Loader.tsx";
import { useNavigate, useParams } from "react-router-dom";
import useCorrection from "@/utils/hooks/useCorrection.ts";
import ExerciseLayout from "@/layouts/ExerciseLayout.tsx";
import CorrectionAnswerSheet from "@/components/v3/correction/CorrectionAnswerSheet.tsx";

function GrammarExerciseCorrection() {
  const { id } = useParams();
  const { getCorrection } = useCorrection();
  const exercise = getCorrection(id!);
  const navigate = useNavigate();  

  return (
    <ExerciseLayout
      isCorrection
      type={ExerciseType.READING}
      title={(exercise as { test_name?: string })?.test_name}
      onClose={() => navigate(-1)}
    >
      {!exercise ? (
        <div className="flex items-center justify-center w-full h-full">
          <SpinnerLoader className={"!h-12 !w-12 border-t-light"} />
        </div>
      ) : (
        <CorrectionAnswerSheet exercise={exercise} />
      )}
    </ExerciseLayout>
  );
}

export default GrammarExerciseCorrection;
